/**
 * @generated SignedSource<<77a81a2e0eb4fedaf31c5ade5e99b7a0>>
 * @relayHash b3b58abba516a7066e43fee230bb62d7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dd5ecfcc11044bcdaad98bea20a111b89a5005066669b87b37b1b8d5ea4e1ca6

import type { ConcreteRequest, Query } from 'relay-runtime';
export type usePremiumGatePremiumGateQuery$variables = Record<PropertyKey, never>;
export type usePremiumGatePremiumGateQuery$data = {
  readonly entitlements: {
    readonly premiumExtensions: {
      readonly isEntitled: boolean;
    };
  } | null | undefined;
};
export type usePremiumGatePremiumGateQuery = {
  response: usePremiumGatePremiumGateQuery$data;
  variables: usePremiumGatePremiumGateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "Entitlements",
    "kind": "LinkedField",
    "name": "entitlements",
    "plural": false,
    "selections": [
      {
        "concreteType": "PremiumExtensionsFeature",
        "kind": "LinkedField",
        "name": "premiumExtensions",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isEntitled"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "usePremiumGatePremiumGateQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "usePremiumGatePremiumGateQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "b3b58abba516a7066e43fee230bb62d7",
    "id": "dd5ecfcc11044bcdaad98bea20a111b89a5005066669b87b37b1b8d5ea4e1ca6",
    "metadata": {},
    "name": "usePremiumGatePremiumGateQuery",
    "operationKind": "query",
    "text": "query usePremiumGatePremiumGateQuery{entitlements{premiumExtensions{isEntitled}}}"
  }
};
})();

(node as any).hash = "53ba2ea71d0cb2a819a38d3bb3e49b44";

export default node;
